<template>
    <div class="column is-full">
        <div class="level">
            <div class="level-item">
                <div>
                    <p class="heading">Orden id</p>
                    <p class="title">#{{order.id}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Estado</p>
                    <p class="title"><span class="tag is-large is-rounded" :class="statusSwitch(order.status)">{{order.getStatusDisplay}}</span></p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Peso kg</p>
                    <p class="title">{{order.cart.totalWeight}}Kg</p>
                </div>
            </div>
        </div>
        
        <b-table
        :data="order.cart.items">
            <template slot-scope="props">
                <b-table-column label="Img." width="100px">
                    <img class="image" :src="props.row.image" alt="product-image">
                </b-table-column>
                <b-table-column label="Titulo">
                    <a target="_blank" :href="prodDetailUrl.replace('0000', props.row.product)" class="has-text-weight-semibold">{{props.row.productTitle}}</a>
                </b-table-column>
                <b-table-column label="Codigo">
                    <p>{{props.row.code}}</p>
                </b-table-column>
                <b-table-column label="Valores">
                    <span v-for="x in props.row.valueNames" :key="x">{{x}}, </span>
                </b-table-column>

                <b-table-column label="Cantidad">
                    <p>{{props.row.quantity}}</p>
                </b-table-column>
                <b-table-column label="Total">
                    <p>{{props.row.currencySymbol}} {{props.row.total}}</p>
                </b-table-column>
            </template>
        </b-table>
        <hr>
        
        <div class="level">
            <div class="level-item">
                <div>
                    <p class="heading">Metodo</p>
                    <p>{{order.payment.getMethodDisplay}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Cotiz. del dia</p>
                    <p>{{order.cart.usdVal}}</p>
                </div>
            </div>
            <div class="level-item" v-if="order.payment.discountCodeDetail">
                <div>
                    <p class="heading">Cupon</p>
                <p >{{order.payment.discountCodeDetail.code}} <span v-if="order.payment.discountCodeDetail.discountFixed != 0">{{order.payment.discountCodeDetail.currencySymbol}}{{order.payment.discountCodeDetail.discountFixed}}</span> <span v-if="order.payment.discountCodeDetail.discountPercent != 0">%{{order.payment.discountCodeDetail.discountPercent}}</span></p>
                </div>
            </div>
        </div>
        <div class="level">
            <div class="level-item">
                <div>
                    <p class="heading">Subtotal UY</p>
                    <p>{{order.payment.orderTotalUy}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Envio UY</p>
                    <p>{{order.payment.shipmentTotalUy}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Descuento UY</p>
                    <p>{{order.payment.discountUy}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Total UY</p>
                    <p class="title is-success">{{order.payment.amountUy}}</p>
                </div>
            </div>
        </div>
        <hr>
        <div class="level">
            <div class="level-item">
                <div>
                    <p class="heading">Subtotal USD</p>
                    <p>{{order.payment.orderTotalUsd}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Envio USD</p>
                    <p>{{order.payment.shipmentTotalUsd}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Descuento USD</p>
                    <p>{{order.payment.discountUsd}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Total USD</p>
                    <p class="title is-success">{{order.payment.amountUsd}}</p>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type:Object,
            default:new Object({})
        },
        prodDetailUrl:{
            type:String,
            default:""
        }
    },
    methods:{
        statusSwitch(status){
            switch (status){
                case 'P':
                    return 'is-info'
                    break
                case 'A':
                    return 'is-success'
                    break
                case 'D':
                    return 'is-danger'
                    break
                case 'SA':
                    return 'is-warning'
                    break
                case 'SA':
                    return 'is-warning'
                    break
                case 'R':
                    return 'is-danger'
                    break
                case 'S':
                    return 'is-success'
                    break
                case 'F':
                    return 'is-success'
                    break
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.card{
    border:0px #fff solid !important;
}

.image{
    border-radius: 5px;
}

</style>